export default __webpack_public_path__ + "static/media/Template11.5836c22e.png";